import React from 'react';
import './ResultsHeader.scss';

const ResultsHeader = ({ className, showMessage, children }) => {
  const defaultClassName = showMessage
    ? 'ResultsHeader ResultsHeader--with-message'
    : 'ResultsHeader';
  return <div className={className || defaultClassName}>{children}</div>;
};

export default ResultsHeader;
